import React, { Fragment } from 'react';
import axios from 'axios';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import AutosaveFeedback from '../components/autoSaveFeedBack';
import { API_URL } from '../../lib/const';
import {
  InputTypeText,
  InputCep,
  FieldSet,
  InputTypeDropdown
} from '../elements';

class Endereco extends React.Component {
  state = {
    cities: [],
    states: []
  };

  componentDidMount() {
    this.mountTimeout = setTimeout(() => {
      const { formApi, scope } = this.props;
      const { values } = formApi.getState();
      const key = scope ? `${scope}.zip_code` : 'zip_code';
      const zip_code = get(values, key);
      if (zip_code) {
        this.fetchAddress(zip_code);
      }
    }, 2000);
  }

  componentWillUnmount() {
    this.unmounted = true;
    clearTimeout(this.mountTimeout);
  }

  // O informed 1.x quebra ("Cannot read properties of undefined (reading
  // 'config')") ao alterar um campo que não está registrado no formulário: campo
  // desligado nos campos dinâmicos ou formulário já desmontado quando a busca do
  // CEP responde. Nesses casos não há o que preencher.
  setFieldValue(name, value) {
    const { formApi, scope } = this.props;
    if (this.unmounted) return;
    try {
      formApi.setValue(scope ? `${scope}.${name}` : name, value);
    } catch (e) {
      // Campo não registrado no formulário.
    }
  }

  fetchAddress(zip_code) {
    const shouldFetchAddress =
      zip_code && zip_code.replace('_', '').length === 8;

    if (shouldFetchAddress) {
      axios.get(`${API_URL}/zipcode/${zip_code}/find`).then(response => {
        if (this.unmounted) return;
        const address = response.data;
        this.setState({
          cities: [{ label: address.city.name, value: address.city.id }],
          states: [{ label: address.uf, value: address.city.state }]
        });
        if (this.props.zipCode) {
          this.setFieldValue('zip_code', zip_code);
        }
        if (address.street && this.props.streetAddress) {
          this.setFieldValue('street_address', address.street);
        }
        if (address.neighborhood && this.props.neighborhood) {
          this.setFieldValue('neighborhood', address.neighborhood);
        }
        if (this.props.state) {
          this.setFieldValue('state', address.city.state);
        }
        if (this.props.city) {
          this.setFieldValue('city', address.city.id);
        }
      });
    } else if (zip_code.length === 0) {
      this.setFieldValue('zip_code', '');
      this.setFieldValue('street_address', '');
      this.setFieldValue('neighborhood', '');
      this.setFieldValue('state', null);
      this.setFieldValue('city', null);
      this.setFieldValue('address_number', '');
      this.setFieldValue('complement_address', '');
    }
  }

  render() {
    const { cities, states } = this.state;
    const { fiador, fields, onValueChange, title, ...props } = this.props;
    return (
      <FieldSet title={fiador ? `Endereço do Fiador ${fiador}` : title}>
        <Fragment>
          {props.zipCode && (
            <InputCep
              field="zip_code"
              autosaveFeedBack={
                <AutosaveFeedback status={get(fields, 'zip_code')} />
              }
              label="CEP"
              col="3"
              helper="Ex: 30100000"
              onChange={e => this.fetchAddress(e.target.value)}
              required
              onValueChange={value => onValueChange('zip_code', value)}
            />
          )}
          {props.streetAddress && (
            <InputTypeText
              field="street_address"
              autosaveFeedBack={
                <AutosaveFeedback status={get(fields, 'street_address')} />
              }
              label="Logradouro"
              col="6"
              helper="Sua rua, avenida, etc."
              required
              onValueChange={value => onValueChange('street_address', value)}
            />
          )}
          {props.addressNumber && (
            <InputTypeText
              field="address_number"
              autosaveFeedBack={
                <AutosaveFeedback status={get(fields, 'address_number')} />
              }
              label="Número"
              col="3"
              helper="Número da sua residência"
              required
              onValueChange={value => onValueChange('address_number', value)}
            />
          )}
          {props.complementAddress && (
            <InputTypeText
              field="complement_address"
              autosaveFeedBack={
                <AutosaveFeedback status={get(fields, 'complement_address')} />
              }
              label="Complemento"
              col="3"
              onValueChange={value =>
                onValueChange('complement_address', value)
              }
            />
          )}
          {props.neighborhood && (
            <InputTypeText
              field="neighborhood"
              autosaveFeedBack={
                <AutosaveFeedback status={get(fields, 'neighborhood')} />
              }
              required
              label="Bairro"
              col="3"
              onValueChange={value => onValueChange('neighborhood', value)}
            />
          )}
          {props.state && (
            <InputTypeDropdown
              field="state"
              autosaveFeedBack={
                <AutosaveFeedback status={get(fields, 'state')} />
              }
              label="Estado"
              col="3"
              required
              options={states}
              onValueChange={value => onValueChange('state', value)}
            />
          )}
          {props.city && (
            <InputTypeDropdown
              field="city"
              autosaveFeedBack={
                <AutosaveFeedback status={get(fields, 'city')} />
              }
              label="Cidade"
              col="3"
              helper="Cidade onde Mora"
              required
              options={cities}
              onValueChange={value => onValueChange('city', value)}
            />
          )}
        </Fragment>
      </FieldSet>
    );
  }
}

Endereco.propTypes = {
  formApi: PropTypes.shape({
    setValue: PropTypes.func,
    getState: PropTypes.func
  }).isRequired,
  scope: PropTypes.string,
  fiador: PropTypes.string,
  fields: PropTypes.shape({
    zip_code: PropTypes.oneOf(['ok', 'pending', 'saving', 'error']),
    street_address: PropTypes.oneOf(['ok', 'pending', 'saving', 'error']),
    address_number: PropTypes.oneOf(['ok', 'pending', 'saving', 'error']),
    complement_address: PropTypes.oneOf(['ok', 'pending', 'saving', 'error']),
    neighborhood: PropTypes.oneOf(['ok', 'pending', 'saving', 'error']),
    state: PropTypes.oneOf(['ok', 'pending', 'saving', 'error']),
    city: PropTypes.oneOf(['ok', 'pending', 'saving', 'error'])
  }),
  onValueChange: PropTypes.func,
  title: PropTypes.string
};

Endereco.defaultProps = {
  fiador: undefined,
  fields: {},
  scope: undefined,
  onValueChange: () => null,
  title: 'Endereço'
};

export default Endereco;
